import { useConfirmation } from '../context/ConfirmationContext';

export default function ConfirmationDialog() {
  const { dialog } = useConfirmation();

  if (!dialog) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl p-6 max-w-sm mx-4 animate-in fade-in duration-300">
        <p className="text-gray-700 font-medium mb-6">
          {dialog.message}
        </p>
        
        <div className="flex gap-3 justify-end">
          <button
            onClick={dialog.onCancel}
            className="px-4 py-2 text-sm font-semibold text-gray-600 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
          >
            {dialog.cancelText}
          </button>
          <button
            onClick={dialog.onConfirm}
            className={`px-4 py-2 text-sm font-semibold rounded-lg text-white transition-colors ${
              dialog.danger
                ? 'bg-red-600 hover:bg-red-700'
                : 'bg-blue-600 hover:bg-blue-700'
            }`}
          >
            {dialog.confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
